import { memo } from "react";

function APTDeliveryStopMarker({ stopNo, backgroundColor, textColor }) {
  const shiftLeft = stopNo && stopNo < 10 ? 0 : -3;
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29 7C29 10.3137 26.3137 13 23 13C19.6863 13 17 10.3137 17 7C17 3.68629 19.6863 1 23 1C26.3137 1 29 3.68629 29 7Z"
        fill={backgroundColor}
      />
      <path
        d="M21.4995 15.2875C17.8642 15.0414 14.9586 12.1358 14.7125 8.50055C13.7 8.17551 12.6205 8 11.5 8C5.70101 8 1 12.701 1 18.5C1 24.299 5.70101 29 11.5 29C17.299 29 22 24.299 22 18.5C22 17.3795 21.8245 16.3 21.4995 15.2875Z"
        fill={backgroundColor}
      />
      <path
        d="M29 7C29 10.3137 26.3137 13 23 13C19.6863 13 17 10.3137 17 7C17 3.68629 19.6863 1 23 1C26.3137 1 29 3.68629 29 7Z"
        stroke={textColor}
      />
      <path
        d="M21.4995 15.2875C17.8642 15.0414 14.9586 12.1358 14.7125 8.50055C13.7 8.17551 12.6205 8 11.5 8C5.70101 8 1 12.701 1 18.5C1 24.299 5.70101 29 11.5 29C17.299 29 22 24.299 22 18.5C22 17.3795 21.8245 16.3 21.4995 15.2875Z"
        stroke={textColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.24659 16.6514C8.17393 17.0964 8.41752 17.9417 8.76229 18.727C9.07989 19.4504 9.54794 20.1391 10.1769 20.7682L10.2172 20.8089C11.5321 22.1233 12.7629 22.761 14.3887 22.7668C14.4859 22.6862 15.0244 22.259 15.2397 21.703C15.2351 21.6997 15.2189 21.649 15.2015 21.6082C15.1252 21.6082 14.3887 21.3323 14.156 21.3119C14.156 21.3119 13.9229 21.7938 13.585 22.053C13.247 22.3121 12.3192 21.8938 11.8234 21.531C11.4045 21.2268 10.9097 20.8745 10.5074 20.4789C10.1085 20.0729 9.8348 19.6691 9.52602 19.246C9.32238 18.9672 8.89912 18.3138 8.98693 17.7543C9.07474 17.1948 9.91583 16.8886 9.91417 16.8633C9.73131 16.1834 9.73963 16.3465 9.52602 15.7489C9.49028 15.736 9.44498 15.7252 9.41298 15.7252C9.01794 15.9321 8.31925 16.2064 8.24659 16.6514ZM14.8897 24C12.9726 24 10.9909 23.1171 9.45184 21.5786L9.42127 21.5458C7.82535 19.9367 6.95528 17.9156 7.00177 15.9664L7.00522 15.8226L7.09433 15.7099C7.2321 15.5347 7.36814 15.3801 7.51107 15.2376C8.03329 14.7155 8.64721 14.316 9.33603 14.0491C9.41955 14.0168 9.51427 14 9.61673 14C9.84878 14 10.3706 14.118 10.504 14.4834C10.7391 15.136 11.0357 15.9875 11.2514 16.802C11.3112 17.0306 11.2527 17.5829 10.9333 17.7843L10.1721 18.2669C10.179 18.2729 10.1755 18.3917 10.2746 18.5273C10.5699 18.932 10.9122 19.3323 11.291 19.718C11.6729 20.093 12.072 20.4331 12.4732 20.7249C12.5516 20.7822 12.6398 20.8153 12.7113 20.8153L12.9748 20.4477L13.2171 20.0659C13.4281 19.7387 13.9563 19.7292 14.0157 19.7292C14.0773 19.7292 14.132 19.7348 14.1828 19.746C15.1855 19.9699 15.7822 20.1623 16.5476 20.5093C16.8877 20.6625 17.1025 21.2794 16.9501 21.6664C16.6849 22.353 16.2854 22.9669 15.7645 23.489C15.6168 23.6358 15.4575 23.7762 15.2896 23.907L15.1773 23.9953L14.8897 24Z"
        fill={textColor}
      />
      <text
        id={2}
        fontFamily="OpenSans-SemiBold, Open Sans"
        fontSize={8}
        fontWeight={500}
        fill={textColor}
      >
        <tspan x={21 + shiftLeft} y={10}>
          {stopNo}
        </tspan>
      </text>
    </svg>
  );
}

export default memo(APTDeliveryStopMarker);
